import { restoreDeletedPhotoApi } from 'api/photo/photoViewerApi'

export const RESTORE_DELETED_PHOTO = 'RESTORE_DELETED_PHOTO' as const

export const restoreDeletedPhotoPlainAction = (photoId: number) => ({
  type: RESTORE_DELETED_PHOTO,
  promise: () => restoreDeletedPhotoApi(photoId),
  photoId,
})
